import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { IMAGES } from "@/data/content";

const LINKS = [
  { label: "Philosophy", href: "#philosophy" },
  { label: "Ecosystem", href: "#ecosystem" },
  { label: "Oracle", href: "#oracle" },
];

export const Navbar = ({ onEnter, onBackToEntrance }) => {
  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 z-50 w-full border-b border-[#C5A059]/10 bg-[#050505]/70 backdrop-blur-xl"
      data-testid="navbar"
    >
      <nav className="mx-auto flex h-16 max-w-[1600px] items-center justify-between px-6 md:px-12">
        <a
          href="#hero"
          className="flex items-center gap-3 transition-opacity duration-300 hover:opacity-80"
          data-testid="brand-logo"
        >
          <img src={IMAGES.logo} alt="Sybils Society" className="h-9 w-auto object-contain md:h-11" />
          <span className="hidden font-serif text-xl tracking-[0.34em] text-white sm:inline">
            SYBILS
          </span>
        </a>

        <div className="hidden items-center gap-10 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="overline text-white/60 transition-colors duration-300 hover:text-[#C5A059]"
              data-testid={`nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-4">
          {onBackToEntrance && (
            <button
              onClick={onBackToEntrance}
              className="hidden items-center gap-1.5 text-xs font-light uppercase tracking-[0.22em] text-white/45 transition-colors duration-300 hover:text-[#C5A059] sm:inline-flex"
              data-testid="veil-back-entrance"
            >
              ↩ Entrance
            </button>
          )}
          <Link
            to="/"
            className="hidden text-xs font-light uppercase tracking-[0.22em] text-white/45 transition-colors duration-300 hover:text-[#C5A059] sm:inline"
            data-testid="veil-back-publication"
          >
            ← Sybils &amp; Society
          </Link>
          <button
            onClick={onEnter}
            className="group relative rounded-full border border-[#C5A059]/50 px-5 py-2 text-xs font-light uppercase tracking-[0.22em] text-[#C5A059] transition-colors duration-300 hover:bg-[#C5A059] hover:text-[#050505]"
            data-testid="nav-enter-council-btn"
          >
            Enter the Council
          </button>
        </div>
      </nav>
    </motion.header>
  );
};

export default Navbar;
